import type { BacktestFormState } from "./types";
import { starterSampleForm, STARTER_SAMPLE } from "./starter-sample.ts";
import { strategyRuleDSLIdentity } from "./strategy-builder.ts";

const sampleRuleIdentity = strategyRuleDSLIdentity(starterSampleForm().strategyDSL);

export function backtestRunOriginAnalyticsParameters(form: BacktestFormState, origin: "starter_sample" | "history" | "strategy") {
  const usesSampleRules = form.symbol === STARTER_SAMPLE.symbol
    && form.strategyMode === "builder"
    && strategyRuleDSLIdentity(form.strategyDSL) === sampleRuleIdentity;
  return {
    run_origin: origin,
    uses_sample_rules: usesSampleRules,
  };
}
